import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import BoxOffice from "../entities/stores/boxOffice";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class BoxOfficeDB extends FirestorePipe {

  public static readonly colName = 'BoxOffices'

  constructor(idEstab: string, idStore: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    if(!idStore)
      throw new Error('Informe o id da loja')
    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${BoxOfficeDB.colName}`);
  }

  public create(data: BoxOffice): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: BoxOffice): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<BoxOffice[]> {
    return this._getAll<BoxOffice>(...params);
  }
  public get(id: string): Promise<BoxOffice> {
    return this._get(id);
  }
  public on(listener: (data: BoxOffice[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default BoxOfficeDB;